import { render, staticRenderFns } from "./ExpenseManage.vue?vue&type=template&id=20a498a6&scoped=true"
import script from "./ExpenseManage.vue?vue&type=script&lang=js"
export * from "./ExpenseManage.vue?vue&type=script&lang=js"
import style0 from "./ExpenseManage.vue?vue&type=style&index=0&id=20a498a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a498a6",
  null
  
)

export default component.exports